import { getGenericEndpoint } from './get.api';
import type { GetMarketingResponse } from './types';

export const getMarketing = async (lang = 'en') => {
	return await getGenericEndpoint<GetMarketingResponse>('marketing', lang);
};
